import React, { PropTypes } from "react";

export default function WishlistView({ children }) {
    return <div>{children}</div>;
}

WishlistView.propTypes = {
    children: PropTypes.arrayOf(PropTypes.node),
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Wishlist/Views/WishlistView.jsx